// extracted by mini-css-extract-plugin
export var redoItem = "_kp-1";
export var redoTrigger = "_kp-0";